// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

// unique id generator
import shortid from 'shortid';

// js utility library
import _ from 'lodash';

// class names utility
import cx from 'classnames';

// import component from material UI
import TextField from 'material-ui/TextField';

import isServer from '../../../lib/isServer';

import {validateField} from '../../../modelValidator';

const textFieldContainerCustomization = {
  style: {
    width: 'calc(33% - 14px)',
    margin: '7px',
    padding: '0px'
  }
};

const textFieldCustomization = {
  underlineShow: false,
  style: {
    width: '100%',
    verticalAlign: 'middle'
  },
  errorStyle: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    position: 'absolute',
    transform: 'translateY(26px)'
  },
  floatingLabelStyle: {
    maxWidth: '100%',
    whiteSpace: 'nowrap'
  }
};


// @muiThemeable() // muiThemeable brings in theme from provider at root, not sure if necessary
export default class CustomTextField extends Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    fieldStyle: PropTypes.object,
    focusColor: PropTypes.string,
    subText: PropTypes.string,
    errorText: PropTypes.string,
    onErrorChange: PropTypes.func,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    errorStyle: PropTypes.object,
    id: PropTypes.string,
    password: PropTypes.bool,
    optional: PropTypes.bool,
    'data-id': PropTypes.string,
    isSubElement: PropTypes.bool,
    validation: PropTypes.object,
    isDirty: PropTypes.bool,
    maxLength: PropTypes.number,
    capitalized: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      React.PropTypes.number
    ]),
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      React.PropTypes.number
    ]),
    proxyVal: PropTypes.oneOfType([
      PropTypes.string,
      React.PropTypes.number
    ]) // used for masked input since text field has no access to actual value
  }

  state = {
    focused: false,
    dirty: false,
    passwordShow: false,
    hasValue: false,
    errors: []
  }

  componentWillMount() {
    this.detectAndValidateChanges();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.value !== nextProps.value) {
      this.validate(nextProps.value);
    }
    if(this.props.proxyVal !== nextProps.proxyVal) {
      this.validate(nextProps.proxyVal);
    }
  }

  // performance optimization
  shouldComponentUpdate = ::PureRenderMixin.shouldComponentUpdate;

  componentWillUnmount() {
    if (this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  onKeyUp(event) {

    if (this.props.maxLength) {
      if (event.target.value.length >= this.props.maxLength) {
          event.preventDefault();
          event.target.value = event.target.value.substring(0, this.props.maxLength);
      }
    }

    // capitalized sentences.
    if (this.props.capitalized) {
      event.target.value = event.target.value.split(' ').map(_.capitalize).join(' ');
    }

    const newVal = event.keyCode === 32 ?
      event.target.value :
      event.target.value && event.target.value.trim && event.target.value.trim();

    if(this.props.onChange) this.props.onChange(event, newVal);
    if(this.props.onKeyUp) this.props.onKeyUp(event, newVal);
    if(!this.props.hasOwnProperty('value') && !this.props.hasOwnProperty('proxyVal')) this.validate(newVal);
  }

  onFocus(event) {
    this.setState(state => _.merge({}, state, {focused: true}));
    if(this.props.onFocus) {
      this.props.onFocus(event, event.target.value && event.target.value.trim && event.target.value.trim());
    }
  }

  onBlur(event) {

    this.setState(state => {
      const updateStateObj = {focused: false};
      if (!state.dirty) updateStateObj.dirty = true; // set dirty if not already dirty
      return _.merge({}, state, updateStateObj);
    }, () => {
      // this will validate any autofills as react sees them as defaultValue (also must be dirty)
      this.detectAndValidateChanges();
    });

    if (this.props.onBlur) {
      this.props.onBlur(event, event.target.value && event.target.value.trim && event.target.value.trim());
    }

  }

  detectAndValidateChanges() {
      // initializing
      const initVal = this.props.hasOwnProperty('value') ? this.props.value :
      this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue :
      this.props.hasOwnProperty('proxyVal') ? this.props.proxyVal : null;

      const hasValidation = this.validate(initVal);
      if (!hasValidation && initVal) { // even without validation, should still set state to dirty if initial value is populated
        this.setState(state => _.assign({}, state, {dirty: true}));
      }
  }

  checkErrors() {
    this.setState(state => state.dirty ? state : _.assign({}, state, {dirty: true}));
  }

  id = shortid.generate()

  validate = (value, initialObj) => {

    this.setState(state => _.assign(state, { hasValue: !_.isEmpty(value) }));
    if(this.props.validation) {
      let updateStateObj = {
        errors: validateField(value, this.props.validation)
      };

      if(initialObj) {
        updateStateObj = _.assign({}, initialObj, updateStateObj);
      }

      // emit error change to parent if diff is not 0.
      const errorCountChange = updateStateObj.errors.length - this.state.errors.length;

      if(this.props.onErrorChange && errorCountChange) {
        this.props.onErrorChange(errorCountChange);
      }

      // update local error state
      this.setState(state => _.assign({}, state, updateStateObj));
      return true;
    }
  }

  passwordShowToggle() {
    this.setState(state => _.merge({}, state, {
      passwordShow: !this.state.passwordShow
    }));
  }

  clear = () => {
    this.onKeyUp(null, null);
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const {
      className,
      style,
      fieldStyle,
      focusColor,
      errorStyle,
      errorText,
      onKeyUp, /* eslint no-unused-vars:0 */
      onFocus,  /* eslint no-unused-vars:0 */
      onBlur,   /* eslint no-unused-vars:0 */
      validation, /* eslint no-unused-vars:0 */
      'data-id': dataId,
      ...unmodifiedProps
    } = this.props;

    const {
      style: textFieldContainerCustomizationStyle,
      ...textFieldContainerCustomizationOther
    } = textFieldContainerCustomization;

    const additionalProps = {
      id: this.props.id || this.id,
      onKeyUp: ::this.onKeyUp,
      onFocus:  ::this.onFocus,
      onBlur:   ::this.onBlur,
    };

    // get booleans
    let errorStr;
    const isError = (this.props.isDirty || this.state.dirty) && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty

    // handle focused state visually
    if(this.state.focused) {
      additionalProps.floatingLabelStyle = _.merge({
        color: focusColor || '#2eb0e3'
      }, textFieldCustomization.floatingLabelStyle);
    }


    // handle error state visually
    if(isError) {
      additionalProps.floatingLabelStyle = {
        color: 'rgb(244, 67, 54)'
      };

      // set error string
      errorStr = (errorText && [errorText] || []).concat(this.state.errors).join(', '); // combine passed in error string and local state errors array
    }

    // handle optional state visually
    if (this.props.optional) {
      if(!isError) {
        additionalProps.errorText = '(optional)';
        additionalProps.errorStyle = _.merge({}, textFieldCustomization.errorStyle, errorStyle, {
          color: this.state.focused ? focusColor || '#2eb0e3' : '#c9c9c9'
        });
      } else {
        additionalProps.errorText = `(optional) ${errorStr}`;
      }
    } else if(isError) {
      additionalProps.autoFocus = true;
      additionalProps.errorText = errorStr;
    }

    if (this.props.subText) {
      additionalProps.errorText = this.props.subText + ' ' + (additionalProps.errorText || '');
    }

    return (
      <div className={cx('text-field-container', 'clearfix', className, {focused: this.state.focused, error: isError, optional: this.props.optional && !isError, 'has-value': this.state.hasValue})}
           style={_.merge({}, textFieldContainerCustomizationStyle, style)} {...textFieldContainerCustomizationOther}>
        <TextField {..._.merge({}, textFieldCustomization, errorStyle && {errorStyle} || {}, fieldStyle && {style: fieldStyle} || {})}
                   {...unmodifiedProps}
                   {...additionalProps}
                   data-id={dataId}
                   type={this.props.password && !this.state.passwordShow && 'password' || unmodifiedProps.type || 'text'}
                   className='text-field'
                   ref='textFieldElem'
                   />
        {
          this.props.password
          &&
          <div className='password-show-toggle' onClick={::this.passwordShowToggle} data-id={`${dataId} ShowToggle`}>
            {this.state.passwordShow ? 'Hide' : 'Show'}
          </div>
        }
        {
          className
          &&
          focusColor
          &&
          <style>
            {
              `
                .${className}.focused .text-field::before {
                  border-top-color: ${focusColor};
                }
              `
            }
          </style>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_TextField/index.js